import React, { useEffect, useState } from "react";

// Hardcoded API URL - change this when deploying
const API_BASE_URL = "https://adequate-goldfish-96.hasura.app/v1/graphql";
const HASURA_ADMIN_SECRET = "MgEI00gz71RDoAcaac7MmnzEKAUhHkq4cFe3d7UcgxAzfLeo8VJ0bb2fL7dwdQnY"; // <-- Replace with your actual secret

function App() {
  const [leaderboard, setLeaderboard] = useState([]);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [gitlog, setGitlog] = useState([]);
  const [showGitlog, setShowGitlog] = useState(false);
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedSeason, setSelectedSeason] = useState("2024");
  const [searchTerm, setSearchTerm] = useState("");
  const [seasons, setSeasons] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPlayers, setTotalPlayers] = useState(0);
  const [allPlayers, setAllPlayers] = useState([]);
  const playersPerPage = 50;

  useEffect(() => {
    fetch(API_BASE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-hasura-admin-secret": HASURA_ADMIN_SECRET
      },
      body: JSON.stringify({
        query: `query { teams(order_by: {name: asc}) { team_id name } }`
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.data && Array.isArray(data.data.teams)) {
          setTeams(data.data.teams);
        } else {
          setTeams([]);
          console.error("Teams API did not return an array:", data);
        }
      })
      .catch(err => {
        setTeams([]);
        console.error("Failed to fetch teams:", err);
      });
  }, []);

  useEffect(() => {
    fetch(API_BASE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-hasura-admin-secret": HASURA_ADMIN_SECRET
      },
      body: JSON.stringify({
        query: `query {
          leaderboard {
            season
          }
        }`
      })
    })
      .then(res => res.json())
      .then(data => {
        console.log("Seasons API response:", data); // Debug log
        if (data.data && Array.isArray(data.data.leaderboard)) {
          const uniqueSeasons = [...new Set(data.data.leaderboard.map(item => item.season))].sort((a, b) => b - a);
          console.log("Unique seasons:", uniqueSeasons); // Debug log
          setSeasons(uniqueSeasons);
          if (uniqueSeasons.length > 0) {
            setSelectedSeason(uniqueSeasons[0].toString());
          }
        } else {
          console.error("Invalid data format:", data);
        }
      })
      .catch(err => {
        console.error("Failed to fetch seasons:", err);
      });
  }, []);

  useEffect(() => {
    fetch(API_BASE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-hasura-admin-secret": HASURA_ADMIN_SECRET
      },
      body: JSON.stringify({
        query: `
          query ($season: Int, $team_id: Int) {
            leaderboard(
              where: {
                season: {_eq: $season}
                ${selectedTeam ? "team_id: {_eq: $team_id}" : ""}
              },
              order_by: {total: desc}
            ) {
              player_id
              name
              leaderboard_teams_team_id {
                name
              }
              total
              season
            }
          }
        `,
        variables: {
          season: parseInt(selectedSeason),
          ...(selectedTeam ? { team_id: parseInt(selectedTeam) } : {})
        }
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.data && Array.isArray(data.data.leaderboard)) {
          setAllPlayers(data.data.leaderboard);
          setTotalPlayers(data.data.leaderboard.length);
        } else {
          setAllPlayers([]);
          setTotalPlayers(0);
          console.error("Leaderboard API did not return an array:", data);
        }
      })
      .catch(err => {
        setAllPlayers([]);
        setTotalPlayers(0);
        console.error("Failed to fetch leaderboard:", err);
      });
  }, [selectedSeason, selectedTeam]);

  const handleRowClick = (player) => {
    setSelectedPlayer(player);
    setShowGitlog(true);
    fetch(API_BASE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-hasura-admin-secret": HASURA_ADMIN_SECRET
      },
      body: JSON.stringify({
        query: `
          query ($player_id: Int, $season: Int) {
            gitlog(where: {
              player_id: {_eq: $player_id}
              season: {_eq: $season}
            }) {
              elapsed
              type
              detail
              comments
              points
              season
              gitlog_fixtures_fixture_id {
                date
                fulltime_home
                fulltime_away
                home_team: team_id_home { name }
                away_team: team_id_away { name }
              }
            }
          }
        `,
        variables: {
          player_id: player.player_id,
          season: parseInt(selectedSeason)
        }
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.data && Array.isArray(data.data.gitlog)) {
          setGitlog(data.data.gitlog);
        } else {
          setGitlog([]);
        }
      })
      .catch(() => setGitlog([]));
  };

  const closeGitlog = () => {
    setShowGitlog(false);
    setSelectedPlayer(null);
    setGitlog([]);
  };

  // Soccer pitch style
  const pitchStyle = {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #3ba635 60%, #2e7d32 100%)",
    border: "8px solid white",
    borderRadius: "30px",
    boxShadow: "0 0 40px 10px #2228",
    padding: 40,
    margin: 0,
    fontFamily: "'Segoe UI', 'Arial', sans-serif",
    position: "relative"
  };

  const centerCircleStyle = {
    position: "absolute",
    top: "50px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "120px",
    height: "120px",
    border: "4px solid white",
    borderRadius: "50%",
    zIndex: 1,
    opacity: 0.2
  };

  const tableStyle = {
    width: "100%",
    background: "rgba(255,255,255,0.95)",
    borderCollapse: "collapse",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 2px 12px #2224"
  };

  const thStyle = {
    background: "#388e3c",
    color: "white",
    fontWeight: "bold",
    border: "2px solid #fff",
    padding: "10px"
  };

  const tdStyle = {
    border: "1px solid #b2dfdb",
    padding: "8px",
    textAlign: "center"
  };

  const modalStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000
  };

  const modalContentStyle = {
    background: "#fff",
    borderRadius: "16px",
    padding: "32px 24px 24px 24px",
    minWidth: "60vw",
    maxHeight: "80vh",
    overflowY: "auto",
    boxShadow: "0 8px 32px #2228"
  };

  const filterStyle = {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginBottom: "30px"
  };

  const selectStyle = {
    fontSize: "1.1rem",
    padding: "6px 12px",
    borderRadius: "6px",
    border: "2px solid #388e3c",
    background: "#e8f5e9",
    minWidth: "200px"
  };

  const labelStyle = {
    color: "white",
    fontWeight: "bold",
    fontSize: "1.2rem",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "center"
  };

  const paginationStyle = {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "20px"
  };

  const pageButtonStyle = {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "2px solid #388e3c",
    background: "#e8f5e9",
    cursor: "pointer",
    fontSize: "1rem"
  };

  // Filter leaderboard by player name
  const filteredLeaderboard = allPlayers.filter(player =>
    player.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Update current page when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // Calculate paginated results
  const paginatedLeaderboard = searchTerm 
    ? filteredLeaderboard 
    : filteredLeaderboard.slice(
        (currentPage - 1) * playersPerPage,
        currentPage * playersPerPage
      );

  const totalPages = Math.ceil(
    searchTerm 
      ? filteredLeaderboard.length / playersPerPage 
      : totalPlayers / playersPerPage
  );

  return (
    <div style={pitchStyle}>
      <div style={centerCircleStyle}></div>
      <h1 style={{
        color: "white",
        textShadow: "2px 2px 8px #222",
        textAlign: "center",
        fontSize: "2.5rem",
        marginBottom: 30
      }}>
        ⚽ Gitball Premier League Leaderboard ⚽
      </h1>
      {/* Search bar */}
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
        <input
          type="text"
          placeholder="Search player name..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{
            fontSize: "1.1rem",
            padding: "8px 16px",
            borderRadius: "8px",
            border: "2px solid #388e3c",
            minWidth: "300px"
          }}
        />
      </div>
      
      <div style={filterStyle}>
        <label style={labelStyle}>
          Team
          <select
            value={selectedTeam}
            onChange={e => setSelectedTeam(e.target.value)}
            style={selectStyle}
          >
            <option value="">All Teams</option>
            {teams.map(team => (
              <option key={team.team_id} value={team.team_id}>
                {team.name}
              </option>
            ))}
          </select>
        </label>
        
        <label style={labelStyle}>
          Season
          <select
            value={selectedSeason}
            onChange={e => setSelectedSeason(e.target.value)}
            style={selectStyle}
          >
            {seasons.map(season => (
              <option key={season} value={season}>
                {season}/{(season + 1).toString().slice(2)}
              </option>
            ))}
          </select>
        </label>
      </div>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Rank</th>
            <th style={thStyle}>Player</th>
            <th style={thStyle}>Team</th>
            <th style={thStyle}>Total Points</th>
          </tr>
        </thead>
        <tbody>
          {paginatedLeaderboard.map((player, index) => (
            <tr key={player.player_id} style={{ cursor: "pointer" }} onClick={() => handleRowClick(player)}>
              <td style={{...tdStyle, fontWeight: "bold"}}>#{index + 1}</td>
              <td style={tdStyle}>{player.name}</td>
              <td style={{...tdStyle, fontSize: "0.95rem"}}>
                {player.leaderboard_teams_team_id?.name || ""}
              </td>
              <td style={{...tdStyle, color: player.total >= 0 ? "#388e3c" : "#d32f2f", fontWeight: "bold"}}>
                {player.total}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {!searchTerm && totalPages > 1 && (
        <div style={paginationStyle}>
          <button 
            style={pageButtonStyle}
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
          >
            First
          </button>
          <button 
            style={pageButtonStyle}
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span style={{ color: "white", fontSize: "1.1rem" }}>
            Page {currentPage} of {totalPages}
          </span>
          <button 
            style={pageButtonStyle}
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
          <button 
            style={pageButtonStyle}
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
          >
            Last
          </button>
        </div>
      )}

      {/* Gitlog Modal */}
      {showGitlog && (
        <div style={modalStyle} onClick={closeGitlog}>
          <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
            <button onClick={closeGitlog} style={{ float: "right", fontSize: 18, background: "#388e3c", color: "#fff", border: "none", borderRadius: 6, padding: "6px 16px", cursor: "pointer" }}>Close</button>
            <h2 style={{ marginTop: 0, color: "#388e3c" }}>{selectedPlayer?.name}'s Gitlog ({selectedSeason})</h2>
            {gitlog.length === 0 ? (
              <p>No records found for this player this season.</p>
            ) : (
              <table style={{ ...tableStyle, fontSize: "0.95rem" }}>
                <thead>
                  <tr>
                    <th style={thStyle}>Date</th>
                    <th style={thStyle}>Fixture</th>
                    <th style={thStyle}>Score</th>
                    <th style={thStyle}>Elapsed</th>
                    <th style={thStyle}>Type</th>
                    <th style={thStyle}>Detail</th>
                    <th style={thStyle}>Comments</th>
                    <th style={thStyle}>Points</th>
                  </tr>
                </thead>
                <tbody>
                  {gitlog.map((g, i) => (
                    <tr key={i}>
                      <td style={tdStyle}>
                        {g.gitlog_fixtures_fixture_id?.date
                          ? new Date(g.gitlog_fixtures_fixture_id.date).toLocaleDateString()
                          : "-"}
                      </td>
                      <td style={tdStyle}>{g.gitlog_fixtures_fixture_id?.home_team?.name} vs {g.gitlog_fixtures_fixture_id?.away_team?.name}</td>
                      <td style={tdStyle}>{g.gitlog_fixtures_fixture_id?.fulltime_home} - {g.gitlog_fixtures_fixture_id?.fulltime_away}</td>
                      <td style={tdStyle}>{g.elapsed}'</td>
                      <td style={tdStyle}>{g.type}</td>
                      <td style={tdStyle}>{g.detail}</td>
                      <td style={tdStyle}>{g.comments}</td>
                      <td style={{...tdStyle, color: g.points >= 0 ? "#388e3c" : "#d32f2f", fontWeight: "bold"}}>{g.points}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
      {/* Pitch lines */}
      <div style={{
        position: "absolute",
        top: 0, left: "50%", width: "4px", height: "100%",
        background: "white", opacity: 0.15, zIndex: 0
      }} />
      <div style={{
        position: "absolute",
        top: 0, left: 0, width: "100%", height: "4px",
        background: "white", opacity: 0.15, zIndex: 0
      }} />
      <div style={{
        position: "absolute",
        bottom: 0, left: 0, width: "100%", height: "4px",
        background: "white", opacity: 0.15, zIndex: 0
      }} />
    </div>
  );
}

export default App;

